export default __webpack_public_path__ + "static/media/LO09.b38b7a05.mp3";